export enum EnvironmentType {
  DEMO        = 'DEMO',
  DEV         = 'DEV',
  LOCAL       = 'LOCAL',
  PRODUCTION  = 'PRODUCTION',
  QA          = 'QA',
  UAT         = 'UAT'
}
